import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import IndividualONboarding from '../components/child/IndividualOnboarding';
import IndividualBankdetails from '../components/child/IndividualBankAccount';
import IndividualDocuments from '../components/child/IndividualDocument';
import IndividualInvestment from '../components/child/IndividualInvestment';

const IndividualClientDetails = () => {
    const { id } = useParams();
    const [activeTab, setActiveTab] = useState("basic");

    return (
        <div className="container mt-4">
            <ul className="nav nav-pills nav-fill d-flex flex-wrap">
                {[
                    { key: "basic", label: "Basic Info" },
                    { key: "bank", label: "Bank Details" },
                    { key: "documents", label: "Documents" },
                    { key: "investment", label: "NAV Investment" }
                ].map((tab) => (
                    <li className="nav-item mx-1" key={tab.key} style={{ flex: "1 1 auto" }}>
                        <button 
                            className={`nav-link ${activeTab === tab.key ? "active" : "bg-secondary text-white"}`} 
                            onClick={() => setActiveTab(tab.key)}
                            style={{ borderRadius: "5px" }} // Optional: Rounded corners
                        >
                            {tab.label}
                        </button>
                    </li>
                ))}
            </ul>

            <div className="mt-3">
                {activeTab === "basic" && <IndividualONboarding person_id={id} />}
                {activeTab === "bank" && <IndividualBankdetails person_id={id} />}
                {activeTab === "documents" && <IndividualDocuments person_id={id} />}
                {activeTab === "investment" && <IndividualInvestment person_id={id} />}
            </div>
        </div>
    );
};

export default IndividualClientDetails;
